import React from 'react';
import * as PropTypes from 'prop-types';

import { FormattedTag } from 'core/components';
import { FormattedMessage } from 'react-intl';
import { formatAmountWithCurrency } from '../../helpers/numbers';

export const ProcessTransaction = ({
  transactionType,
  minimumDeposit,
  maximumDeposit,
  currency,
  locale,
}) => (
  <div className="d-flex align-items-end justify-content-between my-1">
    <FormattedTag className="font-weight-semi-bold text-gray-1" id={`payments.${transactionType}.sum`} />
    <div className="d-inline caption pl-1_5 pl-sm-3 font-weight-normal text-gray-1">
      <FormattedMessage id="min" />:
      <span className="mr-2 text-gray-1 font-weight-semi-bold">&#32;{formatAmountWithCurrency({
        amount: minimumDeposit,
        currency,
        locale
      })}
      </span>
      <FormattedMessage id="max" />:
      <span className="text-gray-1 font-weight-semi-bold">&#32;{formatAmountWithCurrency({
        amount: maximumDeposit,
        currency,
        locale
      })}
      </span>
    </div>
  </div>
);

ProcessTransaction.propTypes = {
  transactionType: PropTypes.string.isRequired,
  minimumDeposit: PropTypes.string.isRequired,
  maximumDeposit: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};
